/* eslint-disable complexity */
import { columnType } from 'components/table/types';
import { tableColumns } from './tables.types';
import _ from 'lodash';
import { NewAccountStatus, NewAccountCreationSource } from 'constants/new_accounts.constants';
import { Box } from '@mui/material';

export const tableData = (data: any) => {
	//const t = useAppSelector(selectTranslations);

	const res = data?.map((item: any) => {
		const currentStep =
			item?.currentStep === 'NEW_USER' ? (
				'פרטי משתמש'
			) : item?.currentStep === 'NEW_BANK_ACCOUNT' ? (
				'פרטי חשבון בנק'
			) : (
				<></>
			);
		return {
			...item,
			currentStep,
			collapseData: item?.boNotes || 'Was denied',
		};
	});
	return res;
};

export const buildColumns = (type: NewAccountStatus, t: any, onDeleteAction?: (accountId: number) => void): columnType[] => {
	const columns: columnType[] = [];
	if (_.has(tableColumns, type)) {
		_.keys(tableColumns[type]).map((element: any) => {
			let customValueHandle = {};
			if (element === 'boNotes' && type === NewAccountStatus.DENIED) {
				customValueHandle = {
					customValueHandle: (value: any, row: Record<string, any>) => {
						return (
							<Box
								sx={{
									cursor: 'pointer',
									alignItems: 'center',
									display: 'flex',
								}}
							>
								{row?.approvedByBoUser?.firstName} {row?.approvedByBoUser?.lastName}
								<Box
									className="arrow-collapse"
									sx={{
										alignItems: 'center',
										display: 'flex',
									}}
								>
									<img src={'/icons/arrow-down-menu.svg'} />
								</Box>
							</Box>
						);
					},
				};
			}
			if (element === 'creationSource' && type === NewAccountStatus.IN_REVIEW) {
				customValueHandle = {
					customValueHandle: (value: string) => {
						if (value === NewAccountCreationSource.HyperWebhook) {
							return (
								<Box
									sx={{
										display: 'inline-flex',
										px: 1,
										py: 0.25,
										borderRadius: '8px',
										backgroundColor: 'rgba(242, 111, 33, 0.12)',
										color: '#F26F21',
										fontWeight: 700,
										fontSize: 12,
									}}
								>
									{t('label.hyper')}
								</Box>
							);
						}
						if (value === NewAccountCreationSource.OpenManual) {
							return (
								<Box
									sx={{
										display: 'inline-flex',
										px: 1,
										py: 0.25,
										borderRadius: '8px',
										backgroundColor: 'rgba(0, 138, 105, 0.12)',
										color: '#008a69',
										fontWeight: 700,
										fontSize: 12,
									}}
								>
									{t('label.open')}
								</Box>
							);
						}
						return null;
					},
				};
			}
			if (element === 'deleteAction' && (type === NewAccountStatus.IN_REVIEW || type === NewAccountStatus.DRAFT || type === NewAccountStatus.DENIED) && onDeleteAction) {
				customValueHandle = {
					customValueHandle: (value: any, row: Record<string, any>) => {
						return (
							<button
								onClick={(e) => {
									e.stopPropagation(); // Prevent row click
									onDeleteAction(row.id);
								}}
								style={{
									padding: '10px',
									backgroundColor: 'rgb(0, 82, 62)',
									color: 'white',
									border: 'none',
									borderRadius: '4px',
									cursor: 'pointer',
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.backgroundColor = 'rgb(0, 62, 48)';
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.backgroundColor = 'rgb(0, 82, 62)';
								}}
							>
								{t('actions.deleteAccount') || 'Delete'}
							</button>
						);
					},
				};
			}
			const props: columnType = {
				fieldId: 'id',
				name: element,
				title: element === 'deleteAction' ? '' : t('page.newAccount.tables.' + element),
				type: tableColumns[type][element],
				sortable: element !== 'deleteAction',
				...customValueHandle,
			};
			columns.push(props);
		});
	}
	return columns;
};
